import { render, staticRenderFns } from "./DkChip.vue?vue&type=template&id=2484eb46&"
import script from "./DkChip.vue?vue&type=script&lang=js&"
export * from "./DkChip.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports